import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=447e85a5&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=447e85a5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447e85a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447e85a5')) {
      api.createRecord('447e85a5', component.options)
    } else {
      api.reload('447e85a5', component.options)
    }
    module.hot.accept("./orderList.vue?vue&type=template&id=447e85a5&scoped=true", function () {
      api.rerender('447e85a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/order/orderList.vue"
export default component.exports